import React, { forwardRef, useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { ReactComponent as MinusIcon } from 'images/minus.svg';
import { ReactComponent as PlusIcon } from 'images/plus.svg';

import {
  AccordionTitle,
  StyledAccordion,
  StyledAccordionDetails,
  StyledAccordionSummary,
} from './style';
import Check from '@mui/icons-material/Check';

export const PKDAccordion = forwardRef(
  ({ data, setAllViewed, hasDangerousElements }, ref) => {
    const theme = createTheme();
    const [expanded, setExpanded] = useState('panel0');
    const initialState = data.map((el, index) => {
      if (index === 0) {
        return {
          id       : `panel${index}`,
          isViewed : true,
        };
      }
      return {
        id       : `panel${index}`,
        isViewed : false,
      };
    });
    const [viewedAccordion, setViewedAccordion] = useState(initialState);
    const handleChange = (panel) => (event, isExpanded) => {
      if (isExpanded) {
        const newState = viewedAccordion.map(({ id, isViewed }) => {
          if (id === panel) {
            return {
              id,
              isViewed : true,
            };
          }
          return {
            id,
            isViewed,
          };
        });
        setViewedAccordion(newState);
      }
      setExpanded(isExpanded ? panel : false);
    };

    const getPanelStyles = (panel) => {
      const findPanel = viewedAccordion.find(
        (panelDetails) => panelDetails.id === panel
      );
      return {
        borderColor : findPanel.isViewed ? '#00778B' : '#d1c3c3c7',
        icon        : findPanel.isViewed
          ? (
            <Check
              fontSize='small' sx={{ color: '#26934d', ml: '5px' }}
            />
          )
          : (
            ''
          ),
      };
    };

    useEffect(() => {
      if (setAllViewed && viewedAccordion.every((value) => value.isViewed)) {
        setAllViewed(true);
      }
    }, [viewedAccordion, setAllViewed]);

    return (
      <ThemeProvider
        theme={theme}>
        <div>
          {data.map((item, index) => (
            <StyledAccordion
              expanded={expanded === `panel${index}`}
              key={item.id}
              onChange={handleChange(`panel${index}`)}
              style={{
                border : `1px solid ${getPanelStyles(`panel${index}`).borderColor}`,
              }}>
              <StyledAccordionSummary
                expandIcon={
                  expanded === `panel${index}`
                    ? (
                      <MinusIcon
                        color={theme.palette.primary.blue1}
                      />
                    )
                    : (
                      <PlusIcon
                        color={theme.palette.primary.blue1}
                      />
                    )
                }
                aria-controls={`panel${index}a-content`}
                id={`panel${index}a-header`}
                data-testid={`accordion-summary-${index}`}>
                <AccordionTitle
                  data-testid={`accordion-title-${index}`}>
                  {getPanelStyles(`panel${index}`).icon}
                  {item.title}
                </AccordionTitle>
              </StyledAccordionSummary>
              <StyledAccordionDetails
                data-testid={`accordion-details-${index}`}>
                {hasDangerousElements
                  ? (
                    <div
                      dangerouslySetInnerHTML={{ __html: item.content }}
                    />
                  )
                  : (
                    <Typography>{item.content}</Typography>
                  )}
              </StyledAccordionDetails>
            </StyledAccordion>
          ))}
        </div>
      </ThemeProvider>
    );
  }
);
